import React, { useEffect, useRef, useState } from 'react'; 
import axios from 'axios';
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Badge, Dropdown } from "react-bootstrap";
import Select from "react-select";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';  
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import DatePicker, { DateObject } from "react-multi-date-picker";
import Drawer from '@mui/material/Drawer';
import vendor_1 from '../../../../images/vendor/vendor_1.jpg';
import vendor_2 from '../../../../images/vendor/vendor_2.jpg';
import vendor_3 from '../../../../images/vendor/vendor_3.jpg';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import csv_ico from '../../../../images/export_icons/csv.ico';
import excel_ico from '../../../../images/export_icons/excel.ico';
import print_ico from '../../../../images/export_icons/print.ico'; 
import bgimage from '../../../../images/vendor/vendor.png';
// import AddRawMaterial from '../../../modal/Purchase_Management/Manage_Vendor/AddRawmaterial'
import AddRawMaterial from '../../../modal/Purchase_Management/Manage_Vendor/AddRawmaterial';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
const Vendors = () => {    
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const tableRef = useRef(null); 
    
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state?.toastMessage) {
            const type = location.state.toastType === 'success' ? toast.success : toast.error;
            type(location.state.toastMessage);
            // ✅ Clear location state so it doesn't show again on refresh
            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);

    const [vendors, setVendors] = useState([]);
    const [page, setPage] = useState(1); //pagination
    const [totalPages, setTotalPages] = useState(1); //pagination
    const [searchTerm, setSearchTerm] = useState(''); //pagination
    const [perPage, setPerPage] = useState(10); //pagination

    const [filterOpen, setFilterOpen] = useState(false);
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    }; 
    const [selectedOption, setSelectedOption] = useState(null);
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const DeleteModal = (id, name, fetchVendors) => {
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Vendor
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>${name}</b></p>
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <defs>
                            <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#5987dd"/>
                                <stop offset=".118" stop-color="#638bd6"/>
                                <stop offset=".316" stop-color="#7d98c3"/>
                                <stop offset=".572" stop-color="#a8aba3"/>
                                <stop offset=".871" stop-color="#e3c678"/>
                                <stop offset="1" stop-color="#ffd364"/>
                            </radialGradient>
                            <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                        </defs>
                        <g id="_27-feel_bad" data-name="27-feel bad">
                            <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                            <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                            <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="34" cy="22" r="1"/>
                            <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="16" cy="22" r="1"/>
                            <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                            <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                            <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                            <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                            <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                            <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                            <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                            <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                            <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                            <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                            <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                        </g>
                    </svg>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false, 
        }).then((result) => {
             if (result.isConfirmed) {
                        // 🔥 Call DELETE API
                        axios.delete(`${baseURL}/managevendor/${id}`)
                            .then(() => {
                                swal.fire({
                                    title: 'Vendor Deleted!',
                                    text: `${name} has been marked as deleted.`,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    customClass: {
                                        title: 'fs-6',
                                        confirmButton: 'btn btn-sm btn-primary',
                                    },
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                }).then(() => {
                                    fetchVendors(); // ✅ Silently refresh list
                                });
                            })
                            .catch((error) => {
                                console.error("Delete failed:", error);
                                swal.fire({
                                    title: 'Error!',
                                    text: 'Something went wrong while deleting.',
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    customClass: {
                                        title: 'fs-6',
                                        confirmButton: 'btn btn-sm btn-primary',
                                    },
                                });
                            });
                    } else {
                        swal.fire({
                            title: 'Delete Cancelled',
                            text: `${name} was not deleted.`,
                            icon: 'info',
                            confirmButtonText: 'OK',
                            customClass: {
                                title: 'fs-6',
                                confirmButton: 'btn btn-sm btn-primary',
                            },
                        });
                    }
    })
    };

    const [categories, setCategories] = useState([]);
    const [businessTypes, setBusinessTypes] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedBusinessType, setSelectedBusinessType] = useState(null);
    const [vendorBusinessName, setVendorBusinessName] = useState('');
    const [vendorEmailId, setVendorEmailId] = useState('');
    const [vendorMobileNo, setVendorMobileNo] = useState('');

    // Fetch Vendor Categories
    useEffect(() => {
    axios
        .get(`${baseURL}/vendorcategory/category/active`)
        .then((response) => {
        const options = response.data.map((category) => ({
            value: category.sno,
            label: category.vendorcategory_name,
        }));

        // Add "Select Vendor Category" as first option
        const withDefault = [{ value: '', label: 'Select Vendor Category' }, ...options];

        setCategories(withDefault);
        setSelectedCategory(withDefault[0]); // Set default selected
        })
        .catch((error) => {
        console.error('Error fetching categories:', error);
        });
    }, [baseURL]);

    // Fetch Business Types
    useEffect(() => {
    axios
        .get(`${baseURL}/businesstype/type/active`)
        .then((response) => {
        const options = response.data.map((type) => ({
            value: type.sno,
            label: type.businesstype_name,
        }));

        // Add "Select Business Type" as first option
        const withDefault = [{ value: '', label: 'Select Business Type' }, ...options];

        setBusinessTypes(withDefault);
        setSelectedBusinessType(withDefault[0]); // Set default selected
        })
        .catch((error) => {
        console.error('Error fetching business types:', error);
        });
    }, [baseURL]);
    

    const onClose = () => {
        setFilterOpen(false);
    };

    //     const fetchVendors = () => {
    //   const filters = {
    //       business_type_id: selectedBusinessType?.value || null,
    //      vendor_category_id: selectedCategory?.value || null,
    //     // vendor_category_id: selectedCategory?.value,
    //     // business_type_id: selectedBusinessType?.value,
    //     vendor_businessname: vendorBusinessName,
    //     vendor_emailid: vendorEmailId,
    //     vendor_mobileno: vendorMobileNo,
    //     date_filter: date_fil_selt_value,
    //   };

    //   if (date_fil_selt_value === 'custom') {
    //     filters.start_date = custom_stdt_fil_value.toISOString().split('T')[0];
    //     filters.end_date = custom_eddt_fil_value.toISOString().split('T')[0];
    //   }

    //   axios
    //     .get(`${baseURL}/managevendor`, { params: filters })
    //     .then((res) => setVendors(res.data.vendors))
    //     .catch((err) => console.error('Error fetching vendors:', err));
    // };

    // const resetFilters = () => {
    //   setSelectedCategory(null);
    //   setSelectedBusinessType(null);
    //   setVendorBusinessName('');
    //   setVendorEmailId('');
    //   setVendorMobileNo('');
    //   setDateFilSeltValue('all');
    //   setTodayFilValue(new Date());
    //   setWeekSTDTFilValue(new Date());
    //   setWeekEDDTFilValue(new Date());
    //   setMonthFilValue(new Date());
    //   setCustomSTDTFilValue(new Date());
    //   setCustomEDDTFilValue(new Date());
    //   fetchVendors();
    // };


    //     useEffect(() => {
    //         fetchVendors();
    //     }, []);

    const [hasFetched, setHasFetched] = useState(false); 

    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();   
        }
        fetchVendors();
    }

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const fetchVendors = (pageNumber = page, perPageCount = perPage, search = searchTerm) => {
        const filters = {
            business_type_id: selectedBusinessType?.value || null,
            vendor_category_id: selectedCategory?.value || null,
            vendor_businessname: vendorBusinessName || '',
            vendor_emailid: vendorEmailId || '',
            vendor_mobileno: vendorMobileNo || '',
            date_filter: date_fil_selt_value,
            page: pageNumber,
            per_page: perPageCount,
            search: search || '',
            branch_id: branch_id || null, // ✅ Include branch_id here
        };

        if (date_fil_selt_value === 'custom') {
            filters.start_date = custom_stdt_fil_value?.toISOString()?.split('T')[0];
            filters.end_date = custom_eddt_fil_value?.toISOString()?.split('T')[0];
        }

        axios
            .get(`${baseURL}/managevendor`, { params: filters })
            .then((res) => {
            const responseData = res?.data || {};
            const vendorList = Array.isArray(responseData.vendors)
                ? responseData.vendors
                : Array.isArray(responseData.data)
                ? responseData.data
                : [];

            const totalCount = responseData.total || vendorList.length || 0;
            const totalPages = responseData.total_pages || Math.ceil(totalCount / perPageCount) || 1;

            setVendors(vendorList);
            setTotalPages(totalPages);
            setHasFetched(true);
            })
            .catch((err) => {
            console.error('Error fetching vendors:', err);
            setVendors([]); // prevent map errors
            setTotalPages(1);
            setHasFetched(true);
            });
    };

    useEffect(() => {
    fetchVendors(page, perPage, searchTerm);
    }, [page, perPage, searchTerm]);

    const resetFilters = () => {
    setSelectedCategory(null);
    setSelectedBusinessType(null);
    setVendorBusinessName('');
    setVendorEmailId('');
    setVendorMobileNo('');
    setDateFilSeltValue('all');
    setTodayFilValue(new Date());
    setWeekSTDTFilValue(new Date());
    setWeekEDDTFilValue(new Date());
    setMonthFilValue(new Date());
    setCustomSTDTFilValue(new Date());
    setCustomEDDTFilValue(new Date());
    setPage(1); // Reset to first page
    fetchVendors(1, perPage, ''); // Reset filters + search
    };

    const handleVendorStatusChange = (vendorId, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;

        axios.post(`${baseURL}/managevendor/status/${vendorId}`, { status: newStatus })
            .then(() => {
                fetchVendors(); // This should refresh the vendor list
            })
            .catch(error => {
                console.error("Error updating vendor status:", error);
            }); 
    };

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(new Date());
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(new Date());
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custum Date" }
    ];

    const exportToCSV = () => {
        const csvRows = [];

        // headers
        const headers = ['Vendors', 'Mobile No/Email id', 'Contact Person', 'Contact Mobile', 'Settlement Type', 'Outstanding Amt', 'Status'];
        csvRows.push(headers.join(','));

        // rows
        vendors.forEach(vendor => {
            const row = [
            `"${vendor.vendor_businessname}"`,
            `"${vendor.vendor_mobileno} / ${vendor.vendor_emailid}"`,
            `"${vendor.person_name}"`,
            `"${vendor.person_mobileno}"`,
            `"${vendor.settlement_type} ${
                vendor.select_type === 0 ? 'Weeks' :
                vendor.select_type === 1 ? 'Months' :
                vendor.select_type === 2 ? 'Years' : ''
            }"`,
            `"₹ ${vendor.opening_balance_amount} ${
                vendor.opening_balance === 0 ? '(+)' : vendor.opening_balance === 1 ? '(-)' : ''
            }"`,
            `${vendor.status === 0 ? 'Active' : 'Inactive'}`
            ];
            csvRows.push(row.join(','));
        });

        // Create blob and download
        const csvString = csvRows.join('\n');
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'vendors.csv');
    };

    // Utility to export Excel
    const exportToExcel = () => {
    // Prepare data
    const data = vendors.map(vendor => ({
        Vendors: vendor.vendor_businessname,
        'Mobile No/Email id': `${vendor.vendor_mobileno} / ${vendor.vendor_emailid}`,
        'Contact Person': vendor.person_name,
        'Contact Mobile': vendor.person_mobileno,
        'Settlement Type': `${vendor.settlement_type} ${
        vendor.select_type === 0 ? 'Weeks' :
        vendor.select_type === 1 ? 'Months' :
        vendor.select_type === 2 ? 'Years' : ''
        }`,
        'Outstanding Amt': `₹ ${vendor.opening_balance_amount} ${
        vendor.opening_balance === 0 ? '(+)' : vendor.opening_balance === 1 ? '(-)' : ''
        }`,
        Status: vendor.status === 0 ? 'Active' : 'Inactive'
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Vendors');
    XLSX.writeFile(workbook, 'vendors.xlsx');
    };

    // Utility to print table
    const printTable = () => {
    const printContent = document.getElementById('kt_datatable_responsive_approved').outerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload(); // reload to restore react state after print
    };

    const [selectedVendorId, setSelectedVendorId] = useState(null);
    const [selectedData, setselData] = useState(null);

    const AddRawMaterialModal = (vendorId, data) => {
        setSelectedVendorId(vendorId); // Save vendor id for modal
        setselData(data);
        setModalType("AddRawMaterial");
        setOpen(true);
    };

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <>

            <style>
                {`
                    @keyframes blink {
                        0%, 100% { opacity: 1; }
                        50% { opacity: 0; }
                    }

                    @keyframes pulse-fire {
                        0% { transform: scale(1); opacity: 1; }
                        50% { transform: scale(1.3); opacity: 0.6; }
                        100% { transform: scale(1); opacity: 1; }
                    }
                    .animate-fire {
                        animation: pulse-fire 1s infinite;
                    }
                `}
            </style>

            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                         <h4 style={{ color: '#025d3a' }}>Manage Vendor</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Puchase Management</li>
                    </ol>
                </div>
                <div className='d-flex align-items-center gap-3 mb-2'>
                    <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                        <span className='me-2'><i class="fa-solid fa-filter fs-8"></i></span>
                        <span className=''>Filter</span>
                    </Link>
                    <Dropdown> 
                        <Dropdown.Toggle
                            as="button"
                            variant="primary"
                            className="btn btn-primary text-white btn-sm"
                            id="tp-btn"
                        >
                            <span className='me-2'><i class="fa-solid fa-circle-down fs-8"></i></span>
                            <span className=''>Export</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item href="#" className='px-2' onClick={(e) => { e.preventDefault(); exportToCSV(); }}>
                                <img
                                    src={csv_ico}
                                    alt="CSV"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>CSV</span>
                            </Dropdown.Item>
                            <Dropdown.Item href="#" className='px-2' onClick={(e) => { e.preventDefault(); exportToExcel(); }}>
                                <img
                                    src={excel_ico}
                                    alt="Excel"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>Excel</span>
                            </Dropdown.Item>
                            {/* <Dropdown.Item href="#" className='px-2' onClick={(e) => { e.preventDefault(); printTable(); }}>
                                <img
                                    src={print_ico}
                                    alt="Print"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>Print</span>
                            </Dropdown.Item> */}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Link to={"/add-vendors"} className="btn btn-primary float-end btn-sm" >
                        <span className='me-2'><i class="fa-solid fa-plus fs-8"></i></span>
                        <span className=''>Add Vendor</span>
                    </Link>
                </div>
                {open && modalType === "AddRawMaterial" && (
                    <AddRawMaterial
                        show={open}
                        onClose={() => setOpen(false)}
                        vendorId={selectedVendorId} // ⬅️ pass vendorId to modal
                        data={selectedData}
                        refresh={softRefresh}
                    />
                )}
            </div>

            <div className="table-container">

                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{  fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={75}>75</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{  fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>

                <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}>
                    <thead>
                        <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-80px'>Vendors</th>
                            <th className='min-w-80px'>Mobile No/Email id</th>
                            <OverlayTrigger
                                trigger={['hover', 'focus']}
                                placement="bottom"
                                overlay={
                                    <Tooltip className="tooltip-popover">
                                        <span className="fs-8 text-white fw-semibold">Contact Person / Mobile No</span>
                                    </Tooltip>
                                }
                            ><th className='min-w-80px'>Contact</th></OverlayTrigger>

                            {/* <th className='min-w-100px'>Settlement Type</th> */}
                               <th className='min-w-80px'>Settlement Type / <OverlayTrigger overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Raw Material Count</span></Tooltip>} >
                                                                        <span>
                                                                            RMC
                                                                        </span>
                                                                </OverlayTrigger> </th>
                            <th className='min-w-80px'>
                                Outst Amt / 
                                <OverlayTrigger overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Settlement Date</span></Tooltip>} >
                                        <span>
                                            S Date
                                        </span>
                                </OverlayTrigger>
                                </th>
                            <th className='min-w-50px'>Score</th>
                            <th className='min-w-50px'>Status</th>
                            <th className='min-w-80px'>Actions</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {vendors?.map?.((vendor, index) => ( 
                            <tr key={index}> 
                                <td>
                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                        <LightGallery
                                            onInit={onInit} 
                                            speed={500}
                                            plugins={[lgThumbnail, lgZoom]}
                                        >
                                            <div data-src={vendor.vendor_image || bgimage} className='border rounded px-1 py-0'>
                                                <img src={vendor.vendor_image || bgimage} alt="vendor" className='cursor-pointer w-45px h-45px' />
                                            </div>
                                        </LightGallery>
                                        <div>
                                            <OverlayTrigger
                                                trigger={['hover', 'focus']}
                                                placement="bottom"
                                                overlay={
                                                    <Tooltip className="toltip-popover">
                                                        <span className="fs-8 text-white">Business Name</span>
                                                    </Tooltip>
                                                }
                                            ><label className='text-black font-w400 fs-7'>{vendor.vendor_businessname}</label></OverlayTrigger>
                                            <div className="d-block">
                                                <OverlayTrigger
                                                    trigger={['hover', 'focus']}
                                                    placement="bottom"
                                                    overlay={
                                                        <Tooltip className="toltip-popover">
                                                            <span className="fs-8 text-white">Category</span>
                                                        </Tooltip>
                                                    }
                                                ><label className="fs-8 text-dark font-w600">{vendor.vendor_category?.name}</label></OverlayTrigger>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <label className='text-black font-w400 fs-7'>{vendor.vendor_mobileno}</label>
                                    <div className="d-block">
                                        <label className="fs-8 text-dark font-w600">{vendor.vendor_emailid}</label>
                                    </div>
                                </td>
                                <td>
                                    <label className='text-black font-w400 fs-7'>{vendor.person_name}</label>
                                    <div className="d-block">
                                        <label className="fs-8 text-dark font-w600">{vendor.person_mobileno}</label>
                                    </div>
                                </td> 
                                
                                <td>
                                    <div className='d-flex align-items-center justify-content-center gap-2'>
                                        <Badge bg="warning" className='text-white fs-7 py-0 px-1'>{vendor.settlement_type}{' '}
                                    {vendor.select_type === 0 ? 'Weeks' :
                                    vendor.select_type === 1 ? 'Months' :
                                    vendor.select_type === 2 ? 'Years' :
                                    ''}</Badge>
                                        <OverlayTrigger  trigger={['hover', 'focus']}
                                                    placement="bottom"
                                                    overlay={
                                                        <Tooltip className="toltip-popover">
                                                            <span className="fs-8 text-white">Raw Material Count</span>
                                                        </Tooltip>
                                                    }>
                                            <Badge bg="danger" className="fs-7 py-0 px-1 text-white font-w600">{String(vendor.raw_material_count).padStart(2, "0")}</Badge>
                                        </OverlayTrigger>
                                    </div>  
                                </td>
                                <td className="text-end">
                                    <label className="fs-7 fw-bold text-info">
                                        <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                        {new Intl.NumberFormat('en-IN').format(vendor.pendingPaidAmount)}
                                    </label>
                                    <label className="d-flex align-items-center justify-content-end flex-row gap-2">
                                        {vendor.is_near_settlement === 1 && (<i className="fa-solid fa-clock animate-fire text-danger fs-4"></i>)}
                                        <span className='text-danger font-w600 fs-7'>{vendor.next_settlement_date ? '[ ' + formatDate(vendor.next_settlement_date) + ' ]' : ''}</span>
                                    </label>
                                </td>
                                <td>
                                    <label
                                        className="text-black font-w600 fs-7 px-2 py-1 rounded"
                                        style={{
                                        backgroundColor:
                                            vendor.score === 100 ? '#d4edda' : '#f8d7da', // light green or light red
                                        color: vendor.score === 100 ? '#155724' : '#721c24', // dark text
                                        border:
                                            vendor.score === 100 ? '1px solid #28a745' : '1px solid #dc3545', // border color
                                        display: 'inline-block',
                                        minWidth: '60px',
                                        textAlign: 'center',
                                        fontWeight: '600', // bold
                                        }}
                                    >
                                        {vendor.score == null
                                        ? '000'
                                        : vendor.score === 100
                                        ? vendor.score
                                        : `-${vendor.score}`}
                                    </label>
                                    </td>




                                <td> 
                                    <div className="form-check form-switch d-flex align-items-center mb-3">
                                            <input
                                                className="form-check-input me-2"
                                                type="checkbox"
                                                role="switch"
                                                checked={vendor.status == 0}
                                                onChange={() => handleVendorStatusChange(vendor.sno, vendor.status)}
                                            />
                                        </div>
                                </td>

                                <td>
                                    <div class="d-flex align-items-center gap-2">
                                            
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Vendor Payment</span></Tooltip>} >
                                            <div className="position-relative d-inline-block">
                                                <Link to={`/vendor-payment?data=${vendor.sno}`}>
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" >
                                                        <span><i className="fa-solid fa-money-bills fs-5 mt-1"></i></span>
                                                    </Button>
                                                </Link>
                                                {vendor.paymentStatusCode === 1 && (
                                                    <span
                                                        className="position-absolute top-0 start-75 translate-middle-x"
                                                        style={{
                                                            animation: 'blink 1s infinite',
                                                            WebkitAnimation: 'blink 1s infinite'
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-circle-exclamation text-danger fs-5"></i>
                                                    </span>
                                                )}
                                            </div>
                                        </OverlayTrigger>

                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Add Raw Material</span></Tooltip>} >
                                            <Button variant="primary tp-btn-light px-2 py-1 me-1"  
                                            onClick={() => AddRawMaterialModal(vendor.sno, vendor)}
                                            >
                                                {/* <span>
                                                    <i className="fas fa-dolly fs-6 mt-1"></i>
                                                </span> */}
                                                <span>
                                                    <i className={`fas fa-dolly fs-6 mt-1 ${vendor.raw_material_count > 0 ? 'text-danger' : ''}`}></i>
                                                </span>

                                            </Button>
                                        </OverlayTrigger>  
                                        
                                        <Dropdown drop=''> 
                                            <Dropdown.Toggle
                                                as="a"
                                                className="i-false cursor-pointer"
                                            >
                                                <Button variant="primary tp-btn-light px-2 py-1 me-1" >
                                                    <span><i class="fa-solid fa-ellipsis-vertical fs-5 mt-1"></i></span>
                                                </Button>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {/* <Dropdown.Item as={Link} to={`/view-vendors/${vendor.sno}`} className='px-2 py-1'> */}
                                                <Dropdown.Item as={Link} to={`/view-vendors?data=${vendor.sno}`} className='px-2 py-1'>
                                                    <div className='d-flex align-items-center'>
                                                        <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                            <span><i class="fa-solid fa-eye fs-5 text-danger"></i></span>
                                                        </div>
                                                        <div className="ms-1 fs-7">View</div>
                                                    </div>
                                                </Dropdown.Item>
                                                {/* <Dropdown.Item as={Link} to={`/edit-vendors/${vendor.sno}`} className='px-2 py-1'> */}
                                                <Dropdown.Item as={Link} to={`/edit-vendors?data=${vendor.sno}`} className='px-2 py-1'>
                                                    <div className='d-flex align-items-center'>
                                                        <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                            <span><i class="fa-solid fa-pen-to-square fs-5 text-danger"></i></span>
                                                        </div>
                                                        <div className="ms-2 fs-7">Edit</div>
                                                    </div>
                                                </Dropdown.Item>
                                                {/* <Dropdown.Item href={"#"} className='px-2 py-1'  
                                                onClick={() => DeleteModal(vendor.sno, vendor.vendor_businessname, fetchVendors)}
                                                >
                                                    <div className='d-flex align-items-center'>
                                                        <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                            <span><i class="fa-solid fa-trash-can fs-5 text-danger"></i></span>
                                                        </div>
                                                        <div className="ms-2 fs-7">Delete</div>
                                                    </div>
                                                </Dropdown.Item> */}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </td>
                            </tr> 
                        ))}
                    </tbody>
                </table>
                
                <div className="d-flex justify-content-between align-items-center mt-3">
                {/* Bottom left: Showing x to y of z entries */}
                <div>
                    {/* {vendors.length > 0 && (
                        <span className="text-muted">
                            Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + vendors.length} of {totalPages * perPage - (perPage - vendors.length)} entries
                        </span>
                    )} */}
                    {vendors?.length > 0 && Array.isArray(vendors) && (
                        <span className="text-muted">
                            Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + vendors.length} of {(totalPages - 1) * perPage + vendors.length} entries
                        </span>
                        )}

                </div>

                {/* Bottom right: Pagination */}
                <nav>
                    <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                        </li>
                        {[...Array(totalPages)].map((_, i) => (
                        <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                        </li>
                        ))}
                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                        </li>
                    </ul>
                </nav>

                </div>
            
            </div>

            <Drawer
                anchor="right" 
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#eb1c23' }}>Vendor Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>
                            {/* <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Vendor Category</label>
                                <Select
                                value={selectedCategory}
                                onChange={setSelectedCategory}
                                options={categories}
                                />
                            </div> */}

                            <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Vendor Category</label>
                            <Select
                                value={selectedCategory}
                                onChange={setSelectedCategory}
                                options={categories}
                                />
                            </div>




                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Vendor Business Name</label>
                               <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Vendor Business Name"
                                value={vendorBusinessName}
                                onChange={(e) => setVendorBusinessName(e.target.value)}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Email ID</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Email ID"
                                    value={vendorEmailId}
                                    onChange={(e) => setVendorEmailId(e.target.value)}
                                    />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Mobile No</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Mobile No"
                                    value={vendorMobileNo}
                                    onChange={(e) => setVendorMobileNo(e.target.value)}
                                    />
                            </div>
                            {/* <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Business Type</label>
                                <Select
                                value={selectedBusinessType}
                                onChange={setSelectedBusinessType}
                                options={businessTypes}
                                />
                            </div> */}

                            
                            <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Business Type</label>
                            <Select
                                value={selectedBusinessType}
                                onChange={setSelectedBusinessType}
                                options={businessTypes}
                                />
                            </div>

                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            // value={"05/18/2020 02:20:36 PM"}
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            // format="DD/MM/YYYY hh:mm:ss A"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        <Button className="me-2 btn-sm" variant="secondary" 
                        // onClick={onClose}
                        onClick={resetFilters}
                        >
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary"
                        onClick={() => {
                        fetchVendors();
                        onClose();
                        }}
                        // onClick={onClose}
                        >
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>
        </>
    )


}
export default Vendors;